import React, { useEffect } from 'react'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from 'react-redux';
import { my_order_list } from '../../redux/actions/CheckoutAction';
import { IMAGE } from '../../redux/apis/Api';
import {
    Alert,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Divider,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function formattedDate(date) {
    const dateObj = new Date(date);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
}

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
    overflowX: "auto",
    marginTop: theme.spacing(2),
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
    backgroundColor: "#262e7e",
    "& th": {
        color: "#fff",
        fontWeight: "600",
        fontSize: "15px",
        padding: "14px",
        position: "sticky",   // 👈 sticky header
        top: 0,
        background: "#262e7e",
        zIndex: 2,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "& td": {
        fontSize: "14px",
        padding: "12px",
    },
}));

export default function OrderList() {
    const dispatch = useDispatch()
    const user = JSON.parse(localStorage.getItem('user'))
    const order = useSelector((state) => state?.checkout?.order_history)

    useEffect(() => {
        (async () => {
            dispatch(my_order_list({ user_id: user?.data?.id || null }))
        })()
    }, [])

    return (
        <div className="container">
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    {order && order?.data?.length > 0 ? (
                        order?.data?.map((data, index) => (
                            <Grid size={12} key={index}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel-${index}-content`}
                                        id={`panel-${index}-header`}
                                    >
                                        {/* <Grid container alignItems="center" spacing={2} >
                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Typography variant="subtitle1" fontWeight="bold">
                                                    Ordered Date : {formattedDate(data?.created_at)}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: "right" }}>
                                                <Typography variant="subtitle1">
                                                    Status:{" "}
                                                    <span
                                                        style={{
                                                            fontWeight: "700",
                                                            color:
                                                                data?.status === "Delivered"
                                                                    ? "green"
                                                                    : data?.status === "On the way"
                                                                        ? "orange"
                                                                        : "#262e7e",
                                                        }}
                                                    >
                                                        {data?.status || data?.display_status}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                        </Grid> */}
                                        <div className='d-flex justify-content-between w-100 align-items-center flex-column-mobile'>
                                            <div>
                                                <p style={{ fontSize: "16px" }}>
                                                    Ordered Date : <span style={{ fontWeight: "700" }}>{formattedDate(data?.created_at)}</span>
                                                </p>
                                                <p style={{ fontSize: "16px" }}>Order ID :
                                                    {" "}
                                                    <span style={{ fontWeight: "700" }}>{data?.order_id}</span>
                                                </p>
                                            </div>
                                            <div>
                                          
                                                <p style={{ fontSize: "16px" }}>Order Status :
                                                    {" "}
                                                    <span className='accepted-class'> {data?.status || data?.display_status}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {/* Address + Payment Info */}
                                        <Grid container spacing={2} sx={{ mb: 2 }}>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography variant="h6" gutterBottom>
                                                    Delivery Address
                                                </Typography>
                                                <Typography>{data?.house_no}, {data?.house_name}, {data?.street_road}, {data?.area}, {data?.city} - {data?.pincode}</Typography>

                                            </Grid>
                                            {/* <Grid size={{ xs: 12, md: 6 }} sx={{ textAlign: "right" }}>
                                                <Typography variant="h6" gutterBottom>
                                                    Payment Info
                                                </Typography>
                                                <Typography>Shipping: ${Number(data?.shipping_price).toFixed(2)}</Typography>
                                                <Typography fontWeight="bold">
                                                    Total Paid: ${Number(data?.paid_amount).toFixed(2)}
                                                </Typography>
                                            </Grid> */}
                                        </Grid>

                                        <Divider sx={{ mb: 2 }} />

                                        {/* Modern Table */}
                                        <Typography variant="h6" gutterBottom>
                                            Ordered Products
                                        </Typography>

                                        <StyledTableContainer component={Paper}>
                                            <Table sx={{ minWidth: 800 }}>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        <TableCell>#</TableCell>
                                                        <TableCell align="center">Image</TableCell>
                                                        <TableCell align="center">Product</TableCell>
                                                        <TableCell align="center">Price</TableCell>
                                                        <TableCell align="center">Ordered Qty</TableCell>
                                                        <TableCell align="center">Available Qty</TableCell>
                                                        <TableCell align="right">Total</TableCell>
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    {data?.product?.map((row, i) => (
                                                        <StyledTableRow key={i}>
                                                            <TableCell>{i + 1}</TableCell>
                                                            <TableCell align="center">
                                                                <img
                                                                    src={IMAGE + "/" + row?.image}
                                                                    alt={row?.product_name}
                                                                    style={{
                                                                        width: "55px",
                                                                        height: "55px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "8px",
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ fontWeight: "500" }}>
                                                                {row?.product_name}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                ₹{Number(row?.purchased_product_price).toFixed(2)}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row?.purchased_product_quantity}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row?.available_quantity || "-"}
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: "600" }}>
                                                                ₹
                                                                {(
                                                                    Number(row?.available_quantity || row?.purchased_product_quantity) *
                                                                    Number(row?.purchased_product_price)
                                                                ).toFixed(2)}
                                                            </TableCell>
                                                        </StyledTableRow>
                                                    ))}

                                                    {/* Shipping + Total Row */}
                                                    <StyledTableRow>
                                                        <TableCell colSpan={6} align="right" sx={{ fontWeight: "600" }}>
                                                            Shipping & Handling
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: "600" }}>
                                                            ₹{Number(data?.shipping_price).toFixed(2)}
                                                        </TableCell>
                                                    </StyledTableRow>
                                                    <StyledTableRow>
                                                        <TableCell colSpan={6} align="right" sx={{ fontWeight: "700", fontSize: "16px" }}>
                                                            Grand Total
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ fontWeight: "700", fontSize: "16px" }}>
                                                            ₹{Number(data?.paid_amount).toFixed(2)}
                                                        </TableCell>
                                                    </StyledTableRow>
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        ))
                    ) : (
                        <Grid size={12}>
                            <Alert severity="warning">You have not placed any order yet!</Alert>
                        </Grid>
                    )}
                </Grid>
            </Box>
        </div>
    )
}
